import {Order, OrderShipment} from '@/app/shared/interface/order.interface';
import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-shipment-list-modal',
  templateUrl: './shipment-list-modal.component.html',
  styleUrls: ['./shipment-list-modal.component.scss']
})
export class ShipmentListModalComponent {
  public order: Order | undefined;
  public shipments: OrderShipment[] = [];
  @ViewChild('shipmentListModal', { static: false }) thisModal: TemplateRef<string>;

  constructor(
    private modalService: NgbModal,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {

  }

  openModal(order: Order, listData: OrderShipment[]) {
    if (isPlatformBrowser(this.platformId)) {
      this.order = order;
      this.shipments = listData;
      this.modalService.open(this.thisModal, {
        ariaLabelledBy: 'shipment-list-Modal',
        centered: true,
        windowClass: 'theme-modal  modal-xl',
      });
    }
  }

  close() {
    this.modalService.dismissAll();
  }

  ngOnDestroy() {
    this.modalService.dismissAll();
  }
}
